export default "__VITE_ASSET__6beda0a6__"